import {Typography} from 'components/Typography';
import classNames from 'classnames';
import React, {FC} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {Tooltip} from 'components/Tooltip';
import {ILabel} from 'modules/products/types';

export interface IProps {
    text: string;
    tooltipText?: string;
    className?: string;
    code: ILabel['code'];
    onClick?: () => void;
}

export const ShieldProduct: FC<IProps> = ({className, text, tooltipText, code, onClick}) => {
    return (
        <div
            className={classNames(className, style.main, tooltipText ? style.withTooltip : '', style[code])}
            onClick={onClick}
        >
            {'EXPERTS_CHOICE' === code && <Icon className={style.shieldIcon} icon={'shine-filled'} />}
            <Tooltip
                className={style.tooltip}
                hidden={!tooltipText}
                overlay={
                    <div className={style.tooltipContent}>
                        <Typography variant={'label-12-r'}>{tooltipText}</Typography>
                    </div>
                }
            >
                <Typography className={style.text} variant={'label-10-r'}>
                    {text}
                </Typography>
            </Tooltip>
        </div>
    );
};
